<template>
    <div class="video-classify-container">
        <div class="topImgBox">
            <img class="img" src="@/assets/img/classify_bg.png" alt="">
        </div>
        <div class="classify-list">
            <van-collapse :accordion="true" v-model="activeNames" v-for="(item,index) in classifyList" :key="index">
                <van-collapse-item :name="index" :is-link="item.children.length !== 0" :disabled="item.children.length == 0">
                    <div slot="title" class="slot-title" @click="clickEvent(item, 1)">
                        <div class="left-icon" v-show="activeNames === index"></div>
                        <div class="title">{{item.title}}</div>
                    </div>
                    <div class="second-level">
                        <div class="item" v-for="(items, indexs) in item.children" :key="indexs" @click="clickEvent(items, 2)">{{items.title}}</div>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </div>
    </div>
</template>

<script>
import { getAllCategory } from '@/api/product'
export default {
    data () {
        return {
            activeNames: -1,
            classifyList: []
        }
    },
    created () {

    },
    mounted () {
        this.getVideoTypeTop()
    },
    methods: {
        clickEvent (item, value) {
            let id = ''
            if (item.children && item.children.length === 0 && value === 1) {
                id = item.id
                // console.log('单击的是一级', item.id)
            }
            if (value === 2) {
                id = item.id
                // console.log('单击的是二级', item.id)
            }
            if (id) {
                console.log(item)
                if (item.id === 106 && item.title === '离心机') {
                    this.$store.commit('setCentrifugeRefresh', true)
                    // 新版离心机筛选页面
                    this.$router.push(
                        {
                            name: 'centrifuge'
                        }
                    )
                    // 直接跳转离心机筛选
                    //  this.$router.push(
                    //     {
                    //         name: 'filterProduct',
                    //         query: {
                    //             // title: item.title,
                    //             category_id: item.id
                    //         }
                    //     }
                    // )
                } else {
                    this.$router.push(
                        {
                            name: 'filterProduct',
                            query: {
                                // title: item.title,
                                category_id: item.id
                            }
                        }
                    )
                }
            }
        },
        getVideoTypeTop () {
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            var params = {}
            getAllCategory(params).then(res => {
                this.$toast.clear()
                res.map((val) => {
                    val.children = []
                })
                this.classifyList = res
                console.log('666', res)
            })
        }
    }
}
</script>

<style lang="scss">
    .video-classify-container{
        padding-top: rem(46);
        flex: 1;
        background: #eeebf4 !important;
        .topImgBox{
            width: 100%;
            height: rem(155);
            .img{
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .classify-list{
            .van-cell{
                padding: 18px 16px;
            }
            .van-icon{
                color: $base-color;
                font-size: rem(18);
            }
            .van-collapse-item__content{
                background: #F7F8FB;
            }
            .van-collapse-item__title--disabled{
                cursor: pointer;
            }
            .slot-title{
                display: flex;
                align-items: center;
                .left-icon{
                    width: 2px;
                    height: rem(16);
                    background: $base-color;
                    border-radius: 5px;
                    margin-right: rem(8);
                }
                .title{
                    color: #333;
                    font-size: rem(14);
                    font-weight: bold;
                }
            }
            .second-level{
                .item{
                    height: rem(50);
                    color: #333;
                    display: flex;
                    align-items: center;
                    padding-left: rem(20);
                    &:not(:last-child){
                        border-bottom: 1px solid #E6E6E6;
                    }
                }
            }
        }
    }
</style>
